var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.active)?_c('pipeline-end-active',{attrs:{"height":_vm.height,"width":_vm.width}}):(_vm.pass)?_c('pipeline-end-default',{attrs:{"height":_vm.height,"width":_vm.width}}):_c('pipeline-end-inactive',{attrs:{"height":_vm.height,"width":_vm.width}})
}
var staticRenderFns = []

export { render, staticRenderFns }